import React from 'react';
import Icon from '../../assets/Icon';
import { ISweep } from '../../store/sweeps/types';
import { ArchivedFlag, ArchivedFlagIconWrapper, Container, DataTemplate, SweepName, SweepStat, SweepStatIcon, SweepStats } from './styles';

interface Props {
    sweep: ISweep;
}

const SweepItem: React.FC<Props> = ({ sweep }) => {
    const getTotalTime = (): string => {

        const totalTime = sweep.times.reduce((acc, time) => acc + ((time.endingAt ? time.endingAt.getTime() : new Date().getTime()) - (time.beginingAt ? time.beginingAt.getTime() : new Date().getTime())), 0);

        const hours = Math.floor(totalTime / (1000 * 60 * 60));
        const minutes = Math.floor(totalTime / (1000 * 60)) % 60;
        const seconds = Math.floor(totalTime / 1000) % 60;

        return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    }
    return <Container>
        {sweep.archivedAt !== null && sweep.archivedAt !== undefined && <React.Fragment>
            <ArchivedFlag />
            <ArchivedFlagIconWrapper>
                <Icon icon={'archived'} color={'#333'} size={20} />
            </ArchivedFlagIconWrapper>
        </React.Fragment>}
        <DataTemplate>
            <SweepName>
                {sweep.name}
            </SweepName>

            <SweepStats>
                <SweepStat>
                    <SweepStatIcon><Icon size={20} icon={'rooms'} color={'#FFF'} /></SweepStatIcon>
                    {sweep.rooms.length}
                </SweepStat>
                <SweepStat>
                    <SweepStatIcon><Icon size={20} icon={'members'} color={'#FFF'} /></SweepStatIcon>
                    {sweep.members.length}
                </SweepStat>
                <SweepStat>
                    <SweepStatIcon><Icon size={20} icon={'timer'} color={'#FFF'} /></SweepStatIcon>
                    {getTotalTime()}
                </SweepStat>
            </SweepStats>
        </DataTemplate>
    </Container>
}

export default SweepItem;